export type Actions =
  | 'ADD_QUESTION'
  | 'MANAGE_FAQS'
  | 'CUSTOMIZE_DISPLAY'
  | 'CUSTOMIZE_LAYOUT'
  | 'CUSTOMIZE_DESIGN'
  | 'ADD_CATEGORY';

const ActionsId: Record<Actions, string> = {
  ADD_QUESTION: 'Add Question & Answer',
  MANAGE_FAQS: 'Manage FAQs',
  CUSTOMIZE_DESIGN: 'Customize Design',
  CUSTOMIZE_DISPLAY: 'Customize Display',
  CUSTOMIZE_LAYOUT: 'Customize Layout',
  ADD_CATEGORY: 'Add Category',
};

export default ActionsId;
